
import { Button, Checkbox, Form, message, Modal, Radio, Skeleton, Typography } from 'antd';
import rightline from 'assets/icons/arrow-right-line.png';
import { EventsApiService } from 'features/events/api/events-api.service';
import { useSettingsUpdateForm } from 'features/events/use-cases/settings-update-form';
// import { useUpdatePostPosnd } from 'features/events/use-cases/update-postpond';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';
import { useEffect, useState } from 'react';
import { TriangleAlert } from 'lucide-react';
import { useUserContext } from 'features/users';
import { useUpdatePostPosnd } from 'features/events/use-cases/update-postpond';

const { Text } = Typography;

interface SettingItem {
    event_id: number;
    setting_id: number;
    setting_name: string;
    setting_type_id: number;
    setting_type_name: string;
    setting_input_type: string;
    setting_group_index_id: number;
    is_active: boolean;
    // Add other properties if needed
}


interface ApiResponse {
    page: number;
    size: number;
    pages: number;
    total: number;
    items: SettingItem[]; // Assuming SettingItem interface is defined
    // Add other properties if they exist
}

export const EventDetailsSetting = ({ id, setShow, show }: { id: any, setShow: any, show: boolean }) => {
    const { user } = useUserContext();
    const [settingData, setSettingData] = useState<SettingItem[]>([]);
    const { isLoading, mutate } = useSettingsUpdateForm();
    const [getLoading, setGetLoading] = useState<boolean>(false);
    const [postPond, setPostpond] = useState('')
    const [ setPostpondDate] = useState<any>('')
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { mutate: updatepostpond, isLoading: loading } = useUpdatePostPosnd()

    const groupedItems: { [key: number]: any[] } = {};
    settingData?.forEach((item: any) => {

        if (!groupedItems[item.setting_type_id]) {
            groupedItems[item.setting_type_id] = [];
        }

        groupedItems[item.setting_type_id].push(item);
    });
    const fetchSettings = async () => {
        setGetLoading(true);
        const response = await EventsApiService().getSettingsData(id);
        const apiResponse = response as ApiResponse;

        if (Array.isArray(apiResponse.items)) {
            const items: SettingItem[] = apiResponse.items;
            setSettingData(items);
            setGetLoading(false);
        }
        // setGetLoading(false);

    };
    const initialFetch = async () => {
        try {



            // const payload: any = {
            //     Flag: "GET",
            //     EventId: +id,
            //     Message: null,
            //     IsPostpone: null,
            //     UserId: null
            // };

            const payload = {
                Flag: "GET",
                EventId: Number(id),
                UserId: 1,
                Message: "",
                IsPostpone: false
            }


            const response: any = await EventsApiService().updatePostpond(payload);
            setPostpondDate(response)
            if (response?.PostPoneMsg) {
                setPostpond(response.PostPoneMsg); // <-- set only the message
            }

        } catch (error: any) {


            // message.error(error?.response?.data?.message || "Something went wrong");
        }
    };
    const onChangeUpdatePostPond = (currentFlag: "SAVE" | "TRIGGEREMAIL") => {
        if (!postPond.trim()) {
            return message.error("Please enter a message");
        }
        // const payload: any = {
        //     Flag: currentFlag,
        //     EventId: +id,
        //     Message: postPond,
        //     IsPostpone: true,
        // };
        const payload: any = {
            Flag: currentFlag,
            EventId: +id,
            Message: postPond,
            IsPostpone: true,
            UserId: user?.user_id || user?.id,

        };

        // if (currentFlag === "TRIGGEREMAIL") {
        //     // 👉 Open modal instead of hitting API
        //     setIsModalOpen(true);
        //     return;
        // }

        // 👉 Direct API call for SAVE
        updatepostpond(payload, {
            onSuccess: (data: any) => {
                setPostpond("");
                message.success(data?.ResponseMessage);
                initialFetch()
                fetchSettings()
                setIsModalOpen(false)
            },
            onError: () => {
                message.error("Failed to update");
            },
        });
    };
    useEffect(() => {
        fetchSettings();
    }, [])
    useEffect(() => {
        initialFetch()
    }, [])

    const handleSubmit = () => {
        const checkedItems: any[] = settingData
            .filter(item => item.is_active)
            .map(item => ({
                event_setting_id: item.setting_id
                ,
                is_active: item.is_active,
            }));
        const formData = {
            event_id: id,
            selected_event_setting: JSON.stringify(checkedItems),
        }
        mutate(formData, {
            onSuccess: () => {
                initialFetch()
                fetchSettings()
            }
        });
    };


    const handleCheckboxChange = (item: SettingItem) => {
        const updatedSettingData = settingData.map(setting => {
            if (setting.setting_id === item.setting_id) {

                return { ...setting, is_active: !setting.is_active };
            }

            return setting;
        });
        setSettingData(updatedSettingData);
    };

    const handleRadioChange = (item: SettingItem, option: string) => {
        const updatedSettingData = settingData.map(setting => {
            if (setting.setting_type_id === item.setting_type_id) {

                return { ...setting, is_active: setting.setting_name === option };
            }

            return setting;
        });

        setSettingData(updatedSettingData);
    };

    return (
        <div  >

            {/* <div className='ar_icon'>
            <SettingOutlined onClick={() => setShow(true)} />
            </div> */}
            <div className='hd_modal'>
                {!show && <button type='button' className='btn' onClick={() => setShow(!show)}>
                    <img src={rightline} />
                </button>}
                <h1>Event Setting</h1>
            </div>
            {getLoading ?
                <Skeleton active paragraph={{ rows: 50 }} />
                :
                <>
                    <FormSectionsSeparator title="">
                        <div className='sbx_1'>
                            {Object.keys(groupedItems).map((settingTypeId: any) => {
                                const firstItem = groupedItems[settingTypeId][0];

                                // 🚫 Hide Event Registration Status for Account role
                                if (user?.role === "Accountant" && firstItem?.setting_type_name === "Event Registration Status") {
                                    return null;
                                }

                                return (
                                    <div key={settingTypeId} className='sb_form'>
                                        <h4>{firstItem.setting_type_name}</h4>

                                        {firstItem.setting_input_type === 'checkbox' && (
                                            <div className='eb_f'>
                                                {groupedItems[settingTypeId]
                                                    .filter((item: SettingItem) => item.setting_name !== "Virtual Event")
                                                    .map((item: SettingItem) => (
                                                        <div key={item.setting_id} className='ef_l'>
                                                            {item.setting_input_type === 'checkbox' && (
                                                                <Checkbox
                                                                    className="ssb_in"
                                                                    name={item.setting_name}
                                                                    checked={item.is_active}
                                                                    onChange={() => handleCheckboxChange(item)}
                                                                >
                                                                    {item.setting_name}
                                                                </Checkbox>
                                                            )}
                                                        </div>
                                                    ))}
                                            </div>
                                        )}

                                        <div className='radio_bx'>
                                            {firstItem.setting_input_type === 'radio' && (
                                                <Radio.Group
                                                    className='ssb_in'
                                                    value={groupedItems[settingTypeId].find((option) => option.is_active)?.setting_name}
                                                    onChange={(e) => handleRadioChange(firstItem, e.target.value)}
                                                >
                                                    {groupedItems[settingTypeId].map((radioOption: SettingItem, index) => {
                                                        if (radioOption.setting_name === 'Postpone Event') {
                                                            return null;
                                                        }

                                                        return (
                                                            <div key={index}>
                                                                {radioOption.setting_type_name !== 'Event Currency' && (
                                                                    <Radio key={radioOption.setting_id} value={radioOption.setting_name}>
                                                                        {radioOption.setting_name}
                                                                    </Radio>
                                                                )}

                                                                {radioOption.setting_type_name === 'Event Currency' &&
                                                                    radioOption.is_active === true && (
                                                                        <Radio key={radioOption.setting_id} value={radioOption.setting_name}>
                                                                            {radioOption.setting_name}
                                                                        </Radio>
                                                                    )}
                                                            </div>
                                                        );
                                                    })}
                                                </Radio.Group>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                            {/* 
                            {user?.role == "SuperAdmin" &&
                                <div className='postpne_text'>
                                    <div className='prt_head'>
                                        <div className='radio_btn'>
                                            <Radio.Group
                                                value={settingData.find(item => item.setting_id === 32)?.is_active ? "Postpone Event" : ""}
                                                onChange={() => handleRadioChange(
                                                    settingData.find(item => item.setting_id === 32)!,
                                                    "Postpone Event"
                                                )}
                                            >
                                                <Radio value="Postpone Event">Postpone Event</Radio>
                                            </Radio.Group>
                                        </div>
                                        <div className='dte_bx'>
                                            <p>{postPondDate?.UpdatedDate}</p>
                                        </div>

                                    </div>
                                    <textarea name="" id="" className='form-control' value={postPond}
                                        onChange={(e) => setPostpond(e.target.value)}></textarea>
                                    <p style={{ color: "red", fontSize: "12px" }}>On trigger notification, an email will be sent to all registrations for the refund request.
                                    </p>
                                    <div className='pst_btn_wrap'>
                                        <Button type="default" onClick={() => onChangeUpdatePostPond("SAVE")} loading={loading}>
                                            Save Message
                                        </Button>
                                        <Button
                                            className="postpone_btn"
                                            style={{
                                                backgroundColor:
                                                    postPondDate?.IsTriggered || postPondDate?.ResponseStatus === 0 || loading
                                                        ? '#d9d9d9'
                                                        : '#ee3124',
                                                borderColor:
                                                    postPondDate?.IsTriggered || postPondDate?.ResponseCode === 0 || loading
                                                        ? '#d9d9d9'
                                                        : '#ee3124',
                                                color:
                                                    postPondDate?.IsTriggered || postPondDate?.ResponseStatus === 0 || loading
                                                        ? '#a0a0a0'
                                                        : '#fff',
                                                cursor:
                                                    postPondDate?.IsTriggered || postPondDate?.ResponseStatus === 0 || loading
                                                        ? 'not-allowed'
                                                        : 'pointer',
                                                opacity:
                                                    postPondDate?.IsTriggered || postPondDate?.ResponseStatus === 0 || loading
                                                        ? 0.6
                                                        : 1,
                                            }}
                                            onClick={() => setIsModalOpen(true)}
                                            disabled={postPondDate?.IsTriggered || postPondDate?.ResponseStatus === 0 || loading}
                                        >
                                            Trigger Notification
                                        </Button>

                                    </div>
                                </div>} */}
                        </div>
                        <Form.Item className='form-button r_side_btn btn_sve' >
                            <Button className='btn' onClick={handleSubmit} loading={isLoading} type='primary'>SAVE</Button>
                        </Form.Item>
                        {/* {isModalOpen && <TriggerNotification isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} onClick={() => onChangeUpdatePostPond("TRIGGEREMAIL")} />} */}
                        {isModalOpen && <Modal
                            open={isModalOpen}
                            closable={false}
                            footer={null}
                            centered
                            className='trigger_modal'
                        >
                            {/* Warning Icon */}
                            <div className="flex flex-col items-center text-center">
                                <div className='icon_box'>
                                    {/* <ExclamationCircleFilled  /> */}
                                    <TriangleAlert stroke='red' />
                                </div>

                                {/* Title */}
                                <h2 className="mt-4 mb-2 font-semibold text-lg">Confirm Trigger</h2>

                                {/* Description */}
                                <Text type="secondary" className='md_text'>
                                    On trigger notification, an email will be sent to all registrations for
                                    the refund request.
                                </Text>
                            </div>

                            {/* Footer Buttons */}
                            <div className="flex justify-center gap-3 mt-6 form_btn">
                                <Button onClick={() => setIsModalOpen(false)}>Cancel</Button>
                                <Button type="primary" danger onClick={() => onChangeUpdatePostPond("TRIGGEREMAIL")} loading={loading}>
                                    Confirm & Send Notification
                                </Button>
                            </div>
                        </Modal>}
                    </FormSectionsSeparator >
                </>}

        </div >
    )
};
